module.exports = __webpack_public_path__ + "img/1407.af996afd.gif";